import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const OverlayMask = ({ show, canvasRef, onClose, message }) => {
    if (!canvasRef.current) return null;

    const { offsetTop, offsetLeft, offsetWidth, offsetHeight } = canvasRef.current;

    return (
        <div>
            {message && (
                <Typography
                    variant="h4" // You can change this to any variant like "h3", "h2", etc.
                    sx={{
                        position: 'absolute',
                        top: "1em", // Adjust this value as needed
                        left: '50%',
                        transform: 'translateX(-50%)',
                        color: 'white',
                        zIndex: 3000,
                    }}
                >
                    {message}
                </Typography>
            )}
            <Box
                sx={{
                    display: show ? 'block' : 'none',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    zIndex: 2,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: offsetTop,
                        left: offsetLeft,
                        width: offsetWidth,
                        height: offsetHeight,
                        backgroundColor: 'transparent',
                        zIndex: 2100,
                    }}
                />
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        color: 'white',
                        zIndex: 2200,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </div>

    );
};

export default OverlayMask;
